import { updateField } from "vuex-map-fields";
import { SET_DESIGNER_MODEL, SET_LIST_POINT_OF_SALES, DELETE_LIST_POINT_OF_SALES } from "@/constants/mutations-type";
import { LIST_POINT_OF_SALES } from "@/constants/storage-type";
export default {
  updateField,
  [SET_DESIGNER_MODEL]:(state, payload)=>{
    state.model = payload
  },
  [SET_LIST_POINT_OF_SALES]:(state, payload)=>{
    state.listPointOfSale = payload
    localStorage.setItem(LIST_POINT_OF_SALES,JSON.stringify(payload))
  },
  [DELETE_LIST_POINT_OF_SALES]: (state) =>{
    state.listPointOfSale = [];
    localStorage.removeItem(LIST_POINT_OF_SALES);
  }
};
